module.exports = __webpack_public_path__ + "static/header-lovesong-logo.ad6cea58.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/header-lovesong-logo.png
// module id = 185
// module chunks = 168707334958949